export const SEARCH_PLACE = {
  LOAD: 'SEARCH_PLACE_LOAD',
  LOAD_ALL: 'SEARCH_PLACE_LOAD_ALL',
  SUCCESS: 'SEARCH_PLACE_SUCCESS',
  FAIL: 'SEARCH_PLACE_FAIL',
};
